<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('setupNews.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          { text: $t('setupNews.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="$router.push({ name: 'create' })">{{
            $t('add_new')
        }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <Input search v-model="search" :placeholder="$t('setupNews.search')" :style="width"
            @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
        </div>
      </ts-panel-wrapper>
      <div class="overflow-auto">
        <Table :columns="columns" :data="resources" :loading="loading">
          <template slot-scope="{ row }" slot="featureImage">
            <img :src="row.feature_image ? row.feature_image : ''" style="width: 150px;" alt="Feature Image"/>
          </template>
          <template slot-scope="{ row }" slot="title">
            <div v-if="$i18n.locale === 'kh'">
              {{ row.title_kh ? row.title_kh : '' }}
            </div>
              <div v-if="$i18n.locale === 'en'">
              {{ row.title_en ?  row.title_en : ''}}
            </div>
          </template>
        <template slot-scope="{ row }" slot="content">
          <Poptip theme="light" placement="left-start" word-wrap width="250" transfer style="cursor: pointer;">
            <template #content>
              <div v-html="$i18n.locale === 'kh' ? row.content_kh : row.content_en"></div>
            </template>
              <div style="max-height: 100px;overflow: scroll;">
                <div  v-html="$i18n.locale === 'kh' ? limitWords(row.content_kh) : limitWords(row.content_en)"></div>
              </div>
          </Poptip>
        </template>
        <template slot-scope="{ row }" slot="categories">
            {{ row.category ? row.category.category_name : '' }}
        </template>
       <template slot-scope="{ row }" slot="is_publish">
          <span class="badge badge-success" v-if="row.is_publish">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </template>
        <template slot-scope="{ row }" slot="createdBy">
              {{ row.user ? row.user.name : '' }}
        </template>
          <template slot-scope="{ row }" slot="action">
               <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroyNews(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
        </template>
        </Table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'setup-news',
  data () {
    return {
      loading: false,
      width: 'width: 300px',
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
     ...mapState('website/setupNews', ['resources', 'pagination']),
      search: {
      get() {
        return this.$store.state.website.setupNews.search
      },
      set(newValue) {
        this.$store.commit('website/setupNews/SET_SEARCH', newValue)
        this.$store.commit('website/setupNews/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('setupNews.image'),
          slot: 'featureImage',
          minWidth: 150,
        },
        {
          title: this.$t('setupNews.newsDate'),
          key: 'news_date',
          minWidth: 200,
          align: 'center',
          sortable: true
        },
        {
          title: this.$i18n.locale === 'kh' ? this.$t('setupNews.titleKH') : this.$t('setupNews.titleEN'),
          slot : 'title',
          minWidth: 300,
        },
        {
          title: this.$i18n.locale === 'kh' ? this.$t('setupNews.contentKH') : this.$t('setupNews.contentEN'),
          slot: 'content',
          key: 'content',
          minWidth: 300,
        },
        {
          title: this.$t('setupNews.categories'),
          slot: 'categories',
          align: 'center',
          minWidth: 100,
        },
        {
          title: this.$t('setupNews.status'),
          slot: 'is_publish',
          minWidth: 150,
          align: 'center',
        },
        {
          title: this.$t('setupNews.createdDate'),
          key: 'created_at',
          minWidth: 200,
        },
        {
          title: this.$t('setupNews.createBy'),
          slot: 'createdBy',
          minWidth: 150,
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100,
        }
      ]
    }
  },
  methods: {
    limitWords(content, wordLimit = 20) {
    if (!content) return '';
    const words = content.split(' ');
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : content;
  },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('website/setupNews/fetch',Object.assign({ ...attributes }))
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
      edit (record) {
      this.$store.commit('website/setupNews/SET_EDIT_DATA',record)
      this.$router.push({
        name : 'news-edit',
        params : { id: record.setup_news_id }
      })
    },
  async destroyNews(record){
    if(await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))){
      record._deleting = true
      this.$store
        .dispatch('website/setupNews/destroy', record.setup_news_id)
        .then(response=>{
          this.fetchData()
          this.$toasted.success(response.message)
          record._deleting = false
        })
        .catch(error=>{
          this.$toasted.error(error.message)
          record._deleting = false
        })
    }
  },
  },
 watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
}
</script>


